import { Card, CardBody } from "reactstrap";

/**
 * Corpo completo da Política de Privacidade e Termos de Uso (v1.1).
 * Fonte única de verdade, usada na página pública (PrivacyPolicy) e na
 * tela de aceite obrigatório (AcceptPrivacyPolicy).
 */
const PolicyContent = () => {
  return (
    <>
      <div className="text-center mb-4">
        <h2 className="mb-1">PORTAL CARREIRA</h2>
        <h4 className="text-muted mb-1">Política de Privacidade e Termos de Uso</h4>
        <p className="mb-0">
          <strong>Kourly Treinamento e Desenvolvimento Digital Ltda.</strong>
        </p>
        <p className="text-muted">CNPJ 46.725.516/0001-02</p>
      </div>

      {/* AVISO IMPORTANTE */}
      <Card
        className="shadow mb-4"
        style={{ border: "1px solid #f5c2c7", backgroundColor: "#fff5f5" }}
      >
        <CardBody>
          <p className="mb-0">
            <strong style={{ color: "#c0392b" }}>AVISO IMPORTANTE:</strong> Este portal
            coleta informações sobre deficiência (PCD), classificadas como dados pessoais
            sensíveis nos termos do artigo 11 da Lei 13.709/2018 (LGPD). O tratamento
            dessas informações ocorre exclusivamente com base no consentimento específico e
            destacado do titular, conforme detalhado nesta Política.
          </p>
        </CardBody>
      </Card>

      {/* PREÂMBULO */}
      <Card className="shadow mb-4">
        <CardBody>
          <h5>Preâmbulo</h5>
          <p>
            Esta Política de Privacidade e Termos de Uso (doravante denominada simplesmente
            'Política') descreve de forma clara e transparente como a Kourly Treinamento e
            Desenvolvimento Digital Ltda., pessoa jurídica de direito privado, inscrita no
            CNPJ sob o número 46.725.516/0001-02, com sede na Rua Caldas Novas, número 50,
            Conjunto 85, Condomínio B Trade, Bairro Bethaville I, Município de Barueri,
            Estado de São Paulo, CEP 06.404-301 (doravante 'Kourly' ou 'nós'), opera a
            plataforma digital denominada Portal Carreira, bem como coleta, usa, armazena,
            compartilha e protege os dados pessoais de seus usuários.
          </p>
          <p>
            O Portal Carreira é uma plataforma digital de recrutamento de acesso restrito,
            destinada exclusivamente aos alunos matriculados ou egressos dos programas de
            formação da Kourly (Club PdP Pro MBA FRAPP, Método FPP, Método REP e Club PdP
            Start). A plataforma conecta esses alunos a recrutadores e empresas
            farmacêuticas parceiras, funcionando como um benefício privado vinculado ao
            vínculo formativo com a Kourly. Não é permitido o acesso ou cadastro de
            candidatos que não possuam vínculo com os programas de formação da Kourly. Ao
            acessar ou utilizar a plataforma, o usuário declara ter lido, compreendido e
            concordado integralmente com esta Política.
          </p>
          <p className="mb-0">
            Esta Política foi elaborada em conformidade com a Lei Federal n. 13.709/2018
            (Lei Geral de Proteção de Dados Pessoais – LGPD), o Marco Civil da Internet (Lei
            Federal n. 12.965/2014), o Código de Defesa do Consumidor (Lei Federal n.
            8.078/1990) e demais normas aplicáveis.
          </p>
        </CardBody>
      </Card>

      {/* 1. DEFINIÇÕES */}
      <Card className="shadow mb-4">
        <CardBody>
          <h5>1. Definições</h5>
          <p>
            Para os fins desta Política, aplicam-se as seguintes definições, nos termos do
            artigo 5 da LGPD:
          </p>
          <ul>
            <li>
              <strong>Dado pessoal:</strong> informação relacionada a pessoa natural
              identificada ou identificável.
            </li>
            <li>
              <strong>Dado pessoal sensível:</strong> dado pessoal sobre origem racial ou
              étnica, convicção religiosa, opinião política, filiação a sindicato ou a
              organização de caráter religioso, filosófico ou político, dado referente à
              saúde ou à vida sexual, dado genético ou biométrico, quando vinculado a uma
              pessoa natural, e dado sobre deficiência (PCD).
            </li>
            <li>
              <strong>Titular:</strong> pessoa natural a quem se referem os dados pessoais
              que são objeto de tratamento.
            </li>
            <li>
              <strong>Controlador:</strong> pessoa natural ou jurídica a quem competem as
              decisões referentes ao tratamento de dados pessoais. Nesta Política, a Kourly
              é a controladora.
            </li>
            <li>
              <strong>Operador:</strong> pessoa natural ou jurídica que realiza o tratamento
              de dados pessoais em nome do controlador.
            </li>
            <li>
              <strong>Encarregado (DPO):</strong> pessoa indicada pelo controlador para
              atuar como canal de comunicação entre o controlador, os titulares dos dados e
              a Autoridade Nacional de Proteção de Dados (ANPD).
            </li>
            <li>
              <strong>Tratamento:</strong> toda operação realizada com dados pessoais, como
              coleta, produção, recepção, classificação, utilização, acesso, reprodução,
              transmissão, distribuição, processamento, arquivamento, armazenamento,
              eliminação, avaliação ou controle da informação, modificação, comunicação,
              transferência, difusão ou extração.
            </li>
            <li>
              <strong>Consentimento:</strong> manifestação livre, informada e inequívoca
              pela qual o titular concorda com o tratamento de seus dados pessoais para uma
              finalidade determinada.
            </li>
            <li>
              <strong>Candidato:</strong> pessoa natural, usuária da plataforma, que cria um
              perfil profissional visando à conexão com recrutadores e empresas.
            </li>
            <li>
              <strong>Recrutador/Empresa:</strong> pessoa jurídica ou seu representante,
              usuário da plataforma, que busca candidatos para processos seletivos no setor
              farmacêutico.
            </li>
          </ul>
        </CardBody>
      </Card>

      {/* 2. DADOS COLETADOS E FINALIDADES DO TRATAMENTO */}
      <Card className="shadow mb-4">
        <CardBody>
          <h5>2. Dados Coletados e Finalidades do Tratamento</h5>

          <h6 className="mt-3">2.1 Dados dos Candidatos</h6>
          <p>
            Para a criação e manutenção do perfil profissional na plataforma, coletamos os
            seguintes dados dos candidatos, com as respectivas bases legais e finalidades:
          </p>

          <p className="mb-1">
            <strong>2.1.1 Dados de Identificação e Contato</strong>
          </p>
          <ul>
            <li>
              <strong>Nome completo</strong> – finalidade: identificação do candidato e
              exibição do perfil.
            </li>
            <li>
              <strong>CPF (Cadastro de Pessoas Físicas)</strong> – finalidade: verificação
              de identidade, unicidade do cadastro e visibilidade para recrutadores
              cadastrados e verificados na plataforma para fins de processo seletivo. O CPF
              é exibido no perfil completo do candidato e no currículo em PDF gerado pela
              plataforma.
            </li>
            <li>
              <strong>Endereço de e-mail</strong> – finalidade: comunicação sobre processos
              seletivos, notificações da plataforma e recuperação de acesso.
            </li>
            <li>
              <strong>Número de telefone celular</strong> – finalidade: contato direto de
              recrutadores e notificações.
            </li>
            <li>
              <strong>Data de nascimento</strong> – finalidade: verificação de maioridade e
              segmentação de perfil.
            </li>
            <li>
              <strong>Endereço completo, cidade e estado</strong> – finalidade: segmentação
              geográfica para oportunidades de emprego.
            </li>
          </ul>
          <p>
            <em>Base legal:</em> execução de contrato ou de procedimentos preliminares
            relacionados a contrato do qual seja parte o titular (artigo 7, inciso V, da
            LGPD), combinado com consentimento (artigo 7, inciso I, da LGPD).
          </p>

          <p className="mb-1">
            <strong>2.1.2 Dados do Perfil Profissional</strong>
          </p>
          <ul>
            <li>
              <strong>Foto de perfil</strong> – finalidade: humanização do perfil e
              identificação visual pelo recrutador.
            </li>
            <li>
              <strong>Link do perfil do LinkedIn</strong> – finalidade: complementação e
              verificação do histórico profissional.
            </li>
            <li>
              <strong>
                Currículo descritivo: descrição profissional, experiências profissionais,
                formação acadêmica e competências
              </strong>{" "}
              – finalidade: apresentação qualificada do candidato aos recrutadores.
            </li>
            <li>
              <strong>Informação sobre habilitação (CNH)</strong> – finalidade: filtro de
              elegibilidade para vagas que exijam habilitação.
            </li>
            <li>
              <strong>Link de vídeo de apresentação (dado opcional)</strong> – finalidade:
              apresentação dinâmica do candidato.
            </li>
            <li>
              <strong>Link de vídeo de propaganda médica (dado opcional)</strong> –
              finalidade: demonstração de competência técnica específica do setor
              farmacêutico.
            </li>
          </ul>
          <p>
            <em>Base legal:</em> consentimento do titular (artigo 7, inciso I, da LGPD),
            sendo que os campos opcionais somente serão utilizados se o candidato optar por
            fornecê-los.
          </p>

          <p className="mb-1">
            <strong>2.1.3 Dado Pessoal Sensível: Informação sobre Deficiência (PCD)</strong>
          </p>
          <p>
            A informação sobre deficiência é classificada como dado pessoal sensível nos
            termos do artigo 11 da LGPD. A coleta e tratamento desse dado ocorrem
            EXCLUSIVAMENTE com base no consentimento específico, destacado e informado do
            titular (artigo 11, inciso I, da LGPD).
          </p>
          <p>
            <em>Mecanismo de coleta:</em> o consentimento para esse dado sensível é obtido
            por meio de checkbox independente e destacado, apresentado de forma separada do
            consentimento geral da plataforma, durante o preenchimento do perfil do
            candidato. O candidato somente terá esse dado registrado se marcar
            voluntariamente essa opção específica, sendo o campo inteiramente opcional.
          </p>
          <p>
            <em>Finalidade específica:</em> possibilitar ao candidato PCD ser identificado
            em processos seletivos que reservam vagas por força da Lei Federal n. 8.213/1991
            (Lei de Cotas), ampliando suas oportunidades de inserção no mercado de trabalho.
            Esse dado será visível aos recrutadores cadastrados exclusivamente para essa
            finalidade.
          </p>
          <p>
            O candidato pode, a qualquer momento, revogar o consentimento para o tratamento
            desse dado sensível, sem que isso acarrete qualquer prejuízo à sua participação
            geral na plataforma, exceto no que se refere especificamente à identificação
            como candidato PCD nos processos seletivos. A revogação é realizada mediante
            acesso ao próprio perfil ou por solicitação ao canal de suporte indicado na
            Seção 10 desta Política.
          </p>

          <h6 className="mt-3">2.2 Dados dos Recrutadores e Empresas</h6>
          <p>Para o cadastro de recrutadores e empresas na plataforma, coletamos:</p>
          <ul>
            <li>
              <strong>Nome da empresa</strong> – finalidade: identificação e exibição para
              candidatos.
            </li>
            <li>
              <strong>CNPJ</strong> – finalidade: verificação da regularidade jurídica da
              empresa.
            </li>
            <li>
              <strong>Endereço de e-mail de contato</strong> – finalidade: comunicações
              operacionais e acesso à plataforma.
            </li>
            <li>
              <strong>Número de telefone de contato</strong> – finalidade: suporte e
              comunicação sobre a utilização da plataforma.
            </li>
          </ul>
          <p>
            <em>Base legal:</em> execução de contrato (artigo 7, inciso V, da LGPD) e
            legítimo interesse do controlador (artigo 7, inciso IX, da LGPD).
          </p>

          <h6 className="mt-3">2.3 Dados Coletados Automaticamente</h6>
          <p className="mb-0">
            A plataforma pode coletar automaticamente dados técnicos de navegação, incluindo
            endereço de IP, tipo de navegador, sistema operacional, páginas acessadas e
            horário de acesso. Esses dados são coletados para fins de segurança e
            diagnóstico técnico, com base no legítimo interesse do controlador (artigo 7,
            inciso IX, da LGPD).
          </p>
        </CardBody>
      </Card>

      {/* 3. USO DOS DADOS E COMPARTILHAMENTO */}
      <Card className="shadow mb-4">
        <CardBody>
          <h5>3. Uso dos Dados e Compartilhamento</h5>

          <h6 className="mt-3">3.1 Finalidades do Tratamento</h6>
          <p>
            Os dados pessoais coletados são utilizados estritamente para as seguintes
            finalidades:
          </p>
          <ul>
            <li>Conexão entre candidatos e recrutadores cadastrados na plataforma.</li>
            <li>
              Exibição do perfil profissional completo do candidato — incluindo CPF — para
              recrutadores cadastrados e verificados, exclusivamente para fins de processo
              seletivo.
            </li>
            <li>
              Geração e emissão de currículo do candidato em formato PDF, incluindo o CPF do
              candidato.
            </li>
            <li>
              Envio de comunicações relacionadas a processos seletivos, atualizações de
              perfil e funcionalidades da plataforma.
            </li>
            <li>Verificação de identidade e prevenção de fraudes.</li>
            <li>Cumprimento de obrigações legais e regulatórias.</li>
            <li>Melhoria contínua da plataforma e de seus recursos.</li>
          </ul>

          <h6 className="mt-3">3.2 Compartilhamento de Dados</h6>
          <p>
            Os dados dos candidatos, incluindo o CPF, são compartilhados com os recrutadores
            e empresas cadastrados e verificados na plataforma, para a finalidade exclusiva
            de avaliação de perfis em processos seletivos. Ao criar um perfil e aceitar esta
            Política, o candidato consente expressamente com essa visibilidade.
          </p>
          <p>
            Além dos recrutadores cadastrados, os dados pessoais poderão ser compartilhados
            com:
          </p>
          <ul>
            <li>
              Prestadores de serviços tecnológicos que atuam como operadores em nome da
              Kourly (ex.: serviços de hospedagem, infraestrutura de nuvem, provedores de
              e-mail transacional), vinculados contratualmente às mesmas obrigações de
              proteção de dados impostas à Kourly.
            </li>
            <li>
              Autoridades públicas, quando exigido por lei, ordem judicial ou regulamentação
              aplicável.
            </li>
          </ul>
          <p>
            A Kourly não vende, aluga nem cede dados pessoais de candidatos ou recrutadores
            a terceiros para fins comerciais próprios de tais terceiros.
          </p>
          <p className="mb-0">
            Os dados dos candidatos NÃO serão transferidos para o exterior. Caso venha a
            ocorrer transferência internacional de dados no futuro, a Kourly se compromete a
            adotar os mecanismos de proteção previstos nos artigos 33 a 36 da LGPD, com
            comunicação prévia aos titulares.
          </p>
        </CardBody>
      </Card>

      {/* 4. DIREITOS DO TITULAR DE DADOS */}
      <Card className="shadow mb-4">
        <CardBody>
          <h5>4. Direitos do Titular de Dados</h5>
          <p>
            Nos termos do artigo 18 da LGPD, o titular dos dados pessoais tem os seguintes
            direitos, que podem ser exercidos a qualquer momento mediante solicitação ao
            responsável pelos dados:
          </p>
          <ul>
            <li>
              <strong>I – Confirmação da existência de tratamento:</strong> obter
              confirmação de que a Kourly realiza o tratamento de seus dados pessoais.
            </li>
            <li>
              <strong>II – Acesso aos dados:</strong> obter acesso aos dados pessoais que a
              Kourly possui sobre você.
            </li>
            <li>
              <strong>III – Correção de dados:</strong> solicitar a correção de dados
              incompletos, inexatos ou desatualizados.
            </li>
            <li>
              <strong>IV – Anonimização, bloqueio ou eliminação:</strong> solicitar a
              anonimização, o bloqueio ou a eliminação de dados desnecessários, excessivos
              ou tratados em desconformidade com a LGPD.
            </li>
            <li>
              <strong>V – Portabilidade:</strong> solicitar a portabilidade dos seus dados
              pessoais a outro fornecedor de serviço ou produto, mediante requisição
              expressa.
            </li>
            <li>
              <strong>VI – Eliminação dos dados tratados com consentimento:</strong>{" "}
              solicitar a eliminação dos dados pessoais tratados com base no seu
              consentimento, exceto nas hipóteses previstas no artigo 16 da LGPD.
            </li>
            <li>
              <strong>VII – Informação sobre compartilhamento:</strong> obter informações
              sobre as entidades públicas e privadas com as quais seus dados foram
              compartilhados.
            </li>
            <li>
              <strong>VIII – Informação sobre possibilidade de não consentir:</strong> ser
              informado sobre a possibilidade de não fornecer consentimento e sobre as
              consequências desta negativa.
            </li>
            <li>
              <strong>IX – Revogação do consentimento:</strong> revogar o consentimento a
              qualquer momento, por procedimento gratuito e facilitado, nos termos do artigo
              8, parágrafo 5, da LGPD. A revogação não afeta a licitude do tratamento
              realizado anteriormente.
            </li>
            <li>
              <strong>X – Petição à ANPD:</strong> peticionar em relação aos seus dados
              perante a Autoridade Nacional de Proteção de Dados (ANPD).
            </li>
          </ul>
          <p className="mb-0">
            Para exercer qualquer dos direitos acima, o titular deve entrar em contato pelo
            e-mail: <strong>suporte@propagandistadeprimeira.com.br</strong>, conforme
            instruções na Seção 10 desta Política.
          </p>
        </CardBody>
      </Card>

      {/* 5. SOLICITAÇÃO DE EXCLUSÃO DE DADOS */}
      <Card className="shadow mb-4">
        <CardBody>
          <h5>5. Solicitação de Exclusão de Dados</h5>
          <p>
            O candidato ou recrutador pode solicitar a exclusão de seus dados pessoais da
            plataforma a qualquer momento. O procedimento é inteiramente gratuito e deve ser
            realizado da seguinte forma:
          </p>
          <ul>
            <li>
              Enviar e-mail para <strong>suporte@propagandistadeprimeira.com.br</strong> com
              o assunto: 'SOLICITAÇÃO DE EXCLUSÃO DE DADOS – Portal Carreira'.
            </li>
            <li>
              No corpo do e-mail, identificar-se com nome completo e CPF (no caso de
              candidatos) ou nome da empresa e CNPJ (no caso de recrutadores), e indicar
              claramente a solicitação de exclusão.
            </li>
          </ul>
          <p className="mb-0">
            A Kourly processará a solicitação e confirmará a exclusão no prazo de até 15
            (quinze) dias úteis, contados do recebimento da requisição, salvo nos casos em
            que a retenção dos dados seja necessária para cumprimento de obrigação legal ou
            regulatória pelo controlador (artigo 16, inciso I, da LGPD) ou para o exercício
            regular de direitos em processo judicial, administrativo ou arbitral (artigo 16,
            inciso IV, da LGPD).
          </p>
        </CardBody>
      </Card>

      {/* 6. PRAZO DE RETENÇÃO DOS DADOS */}
      <Card className="shadow mb-4">
        <CardBody>
          <h5>6. Prazo de Retenção dos Dados</h5>
          <ul>
            <li>
              <strong>Dados dos candidatos:</strong> mantidos enquanto o perfil permanecer
              ativo na plataforma. Após a exclusão voluntária do perfil ou após solicitação
              de exclusão pelo titular, os dados serão eliminados no prazo de 30 (trinta)
              dias, ressalvadas as hipóteses de retenção obrigatória previstas no artigo 16
              da LGPD.
            </li>
            <li>
              <strong>Dados dos recrutadores e empresas:</strong> mantidos enquanto a conta
              permanecer ativa. Após o encerramento, os dados serão eliminados no mesmo
              prazo de 30 (trinta) dias.
            </li>
            <li>
              <strong>Dados de logs e navegação:</strong> retidos pelo prazo de 6 (seis)
              meses, conforme o artigo 15 do Marco Civil da Internet (Lei n. 12.965/2014),
              podendo ser mantidos por prazo superior mediante ordem judicial.
            </li>
            <li>
              <strong>
                Dados necessários para cumprimento de obrigação legal, tributária ou
                regulatória:
              </strong>{" "}
              mantidos pelos prazos estabelecidos na legislação específica aplicável,
              podendo chegar a 5 (cinco) anos conforme o Código Tributário Nacional.
            </li>
          </ul>
          <p className="mb-0">
            Findo o prazo de retenção aplicável, os dados serão eliminados de forma segura
            ou anonimizados, de modo que não seja possível sua associação ao titular.
          </p>
        </CardBody>
      </Card>

      {/* 7. COOKIES */}
      <Card className="shadow mb-4">
        <CardBody>
          <h5>7. Cookies</h5>
          <p>
            O Portal Carreira utiliza exclusivamente cookies estritamente necessários ao
            funcionamento da plataforma, como autenticação de sessão e manutenção do estado
            de login. Esses cookies não requerem consentimento por serem tecnicamente
            indispensáveis ao funcionamento do serviço.
          </p>
          <p className="mb-0">
            A Kourly não utiliza cookies de rastreamento, analytics, publicidade
            comportamental ou qualquer tecnologia de monitoramento de navegação em outros
            sites.
          </p>
        </CardBody>
      </Card>

      {/* 8. SEGURANÇA DOS DADOS */}
      <Card className="shadow mb-4">
        <CardBody>
          <h5>8. Segurança dos Dados</h5>
          <p>
            A Kourly adota medidas técnicas e organizacionais adequadas para proteger os
            dados pessoais coletados contra acesso não autorizado, alteração, divulgação ou
            destruição indevida. As medidas adotadas incluem, entre outras:
          </p>
          <ul>
            <li>
              Controle de acesso por autenticação, limitando o acesso aos dados
              exclusivamente a pessoas autorizadas.
            </li>
            <li>Criptografia de dados em trânsito (protocolo HTTPS/TLS).</li>
            <li>
              Armazenamento de dados em servidores protegidos e sujeitos a obrigações
              contratuais de segurança.
            </li>
            <li>
              Monitoramento periódico dos sistemas para identificação de vulnerabilidades.
            </li>
          </ul>
          <p className="mb-0">
            Em caso de incidente de segurança que possa acarretar risco ou dano relevante
            aos titulares, a Kourly comunicará o fato à ANPD e aos titulares afetados em
            prazo razoável, nos termos do artigo 48 da LGPD.
          </p>
        </CardBody>
      </Card>

      {/* 9. DECISÕES AUTOMATIZADAS E CLASSIFICAÇÃO DE CANDIDATOS */}
      <Card className="shadow mb-4">
        <CardBody>
          <h5>9. Decisões Automatizadas e Classificação de Candidatos</h5>
          <p>
            Em conformidade com o artigo 20 da LGPD, a Kourly informa que o Portal Carreira
            utiliza lógica automatizada para a organização e classificação dos perfis de
            candidatos exibidos aos recrutadores.
          </p>

          <h6 className="mt-3">9.1 Funcionamento do Sistema de Classificação</h6>
          <p>
            Na visão do recrutador, os perfis de candidatos são exibidos em ordem de
            prioridade definida automaticamente pela plataforma, com base no vínculo do
            candidato com os programas de formação da Kourly. A ordem de exibição obedece aos
            seguintes critérios, em sequência decrescente de prioridade:
          </p>
          <ul>
            <li>
              <strong>1º lugar:</strong> candidatos vinculados ao Club PdP Pro MBA FRAPP
              (Diamante).
            </li>
            <li>
              <strong>2º lugar:</strong> candidatos vinculados ao Método FPP (Ouro).
            </li>
            <li>
              <strong>3º lugar:</strong> candidatos vinculados ao Método REP (Prata).
            </li>
            <li>
              <strong>4º lugar:</strong> candidatos sem vínculo formativo registrado na
              plataforma.
            </li>
          </ul>
          <p>
            Essa classificação automática tem como finalidade destacar candidatos com
            formação especializada em propaganda médica e vendas farmacêuticas, segmento em
            que a Kourly atua como desenvolvedora de competências profissionais. A lógica de
            priorização é baseada exclusivamente no vínculo formativo do candidato, sem
            qualquer consideração de dados sensíveis como raça, gênero, deficiência,
            orientação sexual, religião ou origem.
          </p>

          <h6 className="mt-3">9.2 Efeitos e Direito de Revisão</h6>
          <p>
            A classificação automática descrita na Seção 9.1 pode afetar a visibilidade do
            perfil do candidato para os recrutadores, influenciando indiretamente suas
            oportunidades de contato no processo seletivo. Nos termos do artigo 20 da LGPD, o
            candidato tem direito a:
          </p>
          <ul>
            <li>
              Ser informado sobre a existência de decisão automatizada que afete seus
              interesses, o que é cumprido por esta Política.
            </li>
            <li>
              Solicitar revisão da decisão automatizada mediante requerimento ao canal de
              suporte indicado na Seção 10.
            </li>
            <li>
              Receber explicações sobre os critérios e procedimentos utilizados na decisão
              automatizada.
            </li>
          </ul>
          <p>
            Para exercer o direito de revisão, o candidato deve enviar solicitação ao e-mail{" "}
            <strong>suporte@propagandistadeprimeira.com.br</strong> com o assunto 'REVISÃO DE
            DECISÃO AUTOMATIZADA – Portal Carreira', identificando-se com nome completo e
            CPF. A Kourly responderá no prazo de 15 (quinze) dias úteis.
          </p>

          <h6 className="mt-3">9.3 Ausência de Discriminação</h6>
          <p className="mb-0">
            A Kourly declara que o sistema de classificação automática não utiliza, direta ou
            indiretamente, dados pessoais sensíveis como critério de priorização. A ordem de
            exibição baseia-se exclusivamente no programa de formação ao qual o candidato
            está vinculado, critério de natureza estritamente acadêmica e formativa.
          </p>
        </CardBody>
      </Card>

      {/* 10. TERMOS DE USO DA PLATAFORMA */}
      <Card className="shadow mb-4">
        <CardBody>
          <h5>10. Termos de Uso da Plataforma</h5>

          <h6 className="mt-3">10.1 Aceitação dos Termos</h6>
          <p>
            O acesso e a utilização do Portal Carreira estão condicionados à aceitação plena
            e irrestrita desta Política. Ao se cadastrar na plataforma, o usuário confirma
            que leu, entendeu e concorda com todos os termos e condições aqui estabelecidos.
            O aceite é registrado eletronicamente com data e hora, nos termos do artigo 7,
            inciso I, da LGPD.
          </p>

          <h6 className="mt-3">10.2 Elegibilidade</h6>
          <p>
            O Portal Carreira destina-se exclusivamente a: (i) pessoas físicas maiores de 18
            (dezoito) anos que sejam alunos matriculados ou egressos dos programas de
            formação da Kourly (candidatos); e (ii) representantes legais devidamente
            autorizados de pessoas jurídicas cadastradas como parceiras de recrutamento
            (recrutadores e empresas). É vedado o cadastro ou acesso por pessoas que não
            possuam vínculo com os programas de formação da Kourly ou com as empresas
            parceiras cadastradas, bem como por menores de 18 anos.
          </p>

          <h6 className="mt-3">10.3 Responsabilidades do Candidato</h6>
          <p>
            O candidato é inteiramente responsável pela veracidade, precisão e atualização
            das informações fornecidas em seu perfil. A inserção de informações falsas ou
            enganosas poderá implicar o bloqueio ou exclusão do perfil, sem prejuízo das
            responsabilidades civis e penais aplicáveis.
          </p>
          <p>
            O candidato consente expressamente que seu perfil profissional completo —
            incluindo nome, CPF, dados de contato, foto, informações profissionais e
            acadêmicas — será visível para os recrutadores e empresas cadastrados na
            plataforma, exclusivamente para fins de processo seletivo.
          </p>

          <h6 className="mt-3">10.4 Responsabilidades dos Recrutadores e Empresas</h6>
          <p>
            O recrutador ou empresa é responsável pelo uso adequado das informações dos
            candidatos acessadas por meio da plataforma, sendo vedada qualquer utilização
            para finalidades alheias à avaliação de candidatos em processos seletivos. O
            recrutador declara e garante que atuará em conformidade com a LGPD e demais
            normas aplicáveis no tratamento dos dados dos candidatos acessados, incluindo o
            CPF.
          </p>

          <h6 className="mt-3">10.5 Vedações</h6>
          <p>É vedado ao usuário:</p>
          <ul>
            <li>Inserir informações falsas, enganosas ou de terceiros sem autorização.</li>
            <li>
              Utilizar a plataforma para fins ilícitos, discriminatórios ou contrários à
              ordem pública.
            </li>
            <li>
              Realizar engenharia reversa, copiar, distribuir ou modificar qualquer
              componente da plataforma sem autorização expressa da Kourly.
            </li>
            <li>
              Tentar obter acesso não autorizado a sistemas, contas ou dados de outros
              usuários.
            </li>
            <li>
              Utilizar os dados de candidatos acessados na plataforma — incluindo o CPF —
              para quaisquer finalidades além do recrutamento e seleção.
            </li>
          </ul>

          <h6 className="mt-3">10.6 Propriedade Intelectual</h6>
          <p>
            Todos os direitos de propriedade intelectual relativos à plataforma Portal
            Carreira, incluindo sua marca, logotipo, design, código-fonte e conteúdos
            originais, pertencem exclusivamente à Kourly. O usuário adquire apenas uma
            licença de uso restrita, pessoal e intransferível para acesso à plataforma, nos
            termos desta Política.
          </p>

          <h6 className="mt-3">10.7 Limitação de Responsabilidade</h6>
          <p>
            A Kourly atua como intermediadora entre candidatos e recrutadores, não sendo
            parte nos processos seletivos nem responsável pelas decisões de contratação ou
            rejeição tomadas pelos recrutadores e empresas. A Kourly não garante que o
            cadastro na plataforma resultará em contratação ou em qualquer resultado
            específico no mercado de trabalho.
          </p>

          <h6 className="mt-3">10.8 Modificações nos Termos</h6>
          <p className="mb-0">
            A Kourly reserva-se o direito de alterar esta Política a qualquer momento,
            mediante publicação da versão atualizada na plataforma. Alterações substanciais
            serão comunicadas aos usuários por e-mail com antecedência mínima de 15 (quinze)
            dias. O uso continuado da plataforma após a comunicação de alterações implicará
            aceitação dos novos termos.
          </p>
        </CardBody>
      </Card>

      {/* 11. CONTATO DO RESPONSÁVEL PELOS DADOS (DPO) */}
      <Card className="shadow mb-4">
        <CardBody>
          <h5>11. Contato do Responsável pelos Dados (DPO)</h5>
          <p>
            Em atendimento ao artigo 41 da LGPD, a Kourly disponibiliza canal de comunicação
            direto com o responsável pelo tratamento dos dados pessoais na plataforma:
          </p>
          <p className="mb-1">
            <strong>
              Responsável pelo Tratamento de Dados Pessoais (Encarregado/DPO)
            </strong>
          </p>
          <p className="mb-1">Kourly Treinamento e Desenvolvimento Digital Ltda.</p>
          <p className="mb-1">
            E-mail: <strong>suporte@propagandistadeprimeira.com.br</strong>
          </p>
          <p className="mb-1">
            Endereço: Rua Caldas Novas, n. 50, Conjunto 85, Condomínio B Trade, Bairro
            Bethaville I, Barueri/SP, CEP 06.404-301
          </p>
          <p>CNPJ: 46.725.516/0001-02</p>
          <p>
            Para exercer seus direitos como titular de dados, registrar reclamações ou obter
            esclarecimentos sobre o tratamento de seus dados pessoais, entre em contato pelo
            e-mail acima, indicando no assunto: 'PROTEÇÃO DE DADOS – Portal Carreira'. O
            prazo de resposta é de até 15 (quinze) dias úteis a contar do recebimento da
            solicitação.
          </p>
          <p className="mb-0">
            O titular também pode, a qualquer momento, apresentar petição à Autoridade
            Nacional de Proteção de Dados (ANPD), pelo portal:{" "}
            <a href="https://www.gov.br/anpd" target="_blank" rel="noopener noreferrer">
              www.gov.br/anpd
            </a>
            .
          </p>
        </CardBody>
      </Card>

      {/* 12. LEGISLAÇÃO E FORO APLICÁVEIS */}
      <Card className="shadow mb-4">
        <CardBody>
          <h5>12. Legislação e Foro Aplicáveis</h5>
          <p className="mb-0">
            Esta Política é regida pelas leis da República Federativa do Brasil. Para dirimir
            eventuais controvérsias decorrentes desta Política, fica eleito o foro da Comarca
            de Barueri, Estado de São Paulo, com renúncia a qualquer outro, por mais
            privilegiado que seja, exceto nos casos em que a legislação aplicável estabelecer
            foro diverso em favor do consumidor.
          </p>
        </CardBody>
      </Card>

      {/* 13. DATA DE VIGÊNCIA */}
      <Card className="shadow mb-4">
        <CardBody>
          <h5>13. Data de Vigência</h5>
          <p>
            Esta Política de Privacidade e Termos de Uso entra em vigor na data de sua
            publicação na plataforma Portal Carreira e substitui integralmente quaisquer
            versões anteriores.
          </p>
          <p className="mb-1">
            <strong>Data de vigência:</strong> junho de 2026.
          </p>
          <p className="mb-1">
            <strong>Versão:</strong> 1.0
          </p>
          <p className="mb-0">Kourly Treinamento e Desenvolvimento Digital Ltda.</p>
        </CardBody>
      </Card>
    </>
  );
};

export default PolicyContent;
